<template>
  <div style="margin: 0 24px 12px;">

    <div v-if="userForm && JSON.stringify(userForm) != '{}'">
      <el-descriptions title="客户信息" border :column="2" size="small">
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人" >{{ userForm.userInfo.name }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userForm.userInfo.sex == 1?'男':userForm.userInfo.sex == 2?'女':'未知' }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" >{{ userForm.userInfo.phone }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" >{{ userForm.userInfo.shopName}}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="已提交保障单" >{{ userForm.applyNum}}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="剩余保障名额" >{{ userForm.notApplyNum}}</el-descriptions-item>
      </el-descriptions>
      <el-form ref="formRef" label-width="100px" label-position="left" :inline="true" style="margin-top: 24px;">
        <el-form-item label="赠送保障名额：">
          <el-input type="text" v-model="giveNum" placeholder="请输入赠送次数" style="width: 100%"/>
          <div style="color: red">*负数代表扣除次数</div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" v-loading="subLoading" :disabled="subLoading" @click="summit">确定</el-button>
      </div>
    </div>
    <div class="search-box" v-else>
      <label>手机号：</label>
      <el-input type="search" v-model="searchValue" placeholder="请输入手机号" :maxlength="11" style="margin-right: 8px; width: 16em">
        <template #prefix>
          <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
        </template>
      </el-input>
      <el-button type="primary" @click="getUserInfo()" v-loading="loading">查询</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, getFormData, postJson} from "@/api/api"
import {getGiveUserInfo, medicalSecurityGiveNum} from "@/api/url";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import {phoneReg, intReg} from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  components: {SearchUidOrPhone},
  props: {
    value: Object
  },
  data() {
    return {
      idx: this.value.idx,
      userForm: '',
      giveNum: '',
      searchValue: '',
      loading: false,
      subLoading: false
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!intReg.test(this.giveNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确次数',
          type: 'warning'
        });
        return false
      }else if(this.giveNum == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '赠送次数不能为0',
          type: 'warning'
        });
        return false
      }
      this.subLoading = true
      let param = {}
      param['id'] = this.userForm.id;
      param['num'] = this.giveNum;
      postFormData(medicalSecurityGiveNum, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.subLoading = false
      }).catch(()=>{
        this.subLoading = false
      })
    },



    getUserInfo() {
      if(!phoneReg.test(this.searchValue)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '手机号码格式错误',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      getFormData(getGiveUserInfo, {phone: this.searchValue}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.userForm = data.data
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=> {
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.search-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  background-color: #f5f7fa;
  padding: 24px 0;
}
</style>
